// import React from "react";

// const ExportSuccessPopup = ({ onClose }) => {
//   return (
//     <div className="bg-white w-[30%] rounded-lg p-6 shadow-xl text-center">
//       <h2 className="text-xl font-semibold mb-4 text-green-600">Export Successful!</h2>
//       <p className="mb-4">Your data has been exported successfully.</p>
//       <button
      
//         className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 "
//       >
//         Close
//       </button>
//     </div>
//   );
// };

// export default ExportSuccessPopup;

import React from "react";
const  ExportSuccessPopup= ({isOpen, onClose }) => {


  return (<>
   {isOpen && <>
     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
      <div className="bg-white rounded-xl shadow-lg p-6 text-center w-[300px]">
        <div className="flex justify-center">
          <div className="bg-red-500 rounded-full p-4 mb-4">
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>
        <p className="text-lg font-medium text-gray-800 mb-3">
          Fields Updated Successfully!!! ✅
        </p>
        <button
          className="bg-red-600 text-white px-5 py-2 rounded font-semibold hover:bg-red-700"
          onClick={onClose}
        >
          Done
        </button>
      </div>
    </div>
    </>
   }
 </> );
};
export default ExportSuccessPopup;
